module.exports = __webpack_public_path__ + "static/img/img7.2af0db5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img7.png
// module id = 5Cw+
// module chunks = 1